import { FlowNodeTypes } from '../components/types';
export function getNodeSchedulesIds(actions) {
    return actions
        ? actions.reduce((acc, { nodeType, payload }) => nodeType === FlowNodeTypes.BUSINESS_HOURS &&
            !acc.includes(payload.scheduleId)
            ? [...acc, payload.scheduleId]
            : acc, [])
        : [];
}
